export default __webpack_public_path__ + "static/media/InformaLogo.3c020fb7.png";